"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTreeSpeciesByKey = exports.tree_species_map = exports.tree_species_list = exports.tree_species = void 0;
const util_1 = require("./util");
// In order to remove carboncrop species from our codebase, we need to remove the association that is used to get
// tree height from carboncrop species and replace it with a system using the new data.The safest way to implement
// this is to add height to all tree species in tupuake - species - name.ts in ets - polygon.
// In order to do that, the following process was used:
// For each carboncrop species, apply the existing height value to all corresponding tupu ake species
// For the rest, go to https://www.nzpcn.org.nz/flora/species/. If the height does not exist, put undefined.
// If it exists choose the highest number.
exports.tree_species = [
    {
        key: 'acer_rubrum',
        display_name: 'Acer rubrum',
        tupuake_id: 8,
        predominant_species_key: 'maples__birches__alders',
        mature_height_meters: 15,
    },
    {
        key: 'acer_saccharum',
        display_name: 'Acer saccharum',
        tupuake_id: 9,
        predominant_species_key: 'maples__birches__alders',
        mature_height_meters: 15,
    },
    {
        key: 'agathis_australis',
        display_name: 'Agathis australis',
        tupuake_id: 10,
        predominant_species_key: 'podocarps',
        mature_height_meters: 60,
    },
    {
        key: 'alder_species_alnus_spp',
        display_name: 'Alder species (Alnus spp)',
        tupuake_id: 175,
        predominant_species_key: 'maples__birches__alders',
        mature_height_meters: 30,
    },
    {
        key: 'alectryon_excelsus',
        display_name: 'Alectryon excelsus',
        tupuake_id: 11,
        predominant_species_key: 'broadleaved_species',
        mature_height_meters: 20,
    },
    {
        key: 'aristotelia_serrata',
        display_name: 'Aristotelia serrata',
        tupuake_id: 13,
        predominant_species_key: 'broadleaved_species',
        mature_height_meters: 10,
    },
    {
        key: 'arizona_cypress_cupressus_arizonica',
        display_name: 'Arizona cypress (Cupressus arizonica)',
        tupuake_id: 176,
        predominant_species_key: 'cypresses',
        mature_height_meters: 20,
    },
    {
        key: 'ash_fraxinus_excelsior',
        display_name: 'Ash (Fraxinus excelsior)',
        tupuake_id: 177,
        predominant_species_key: 'rowan__mountain_ash__ash',
        mature_height_meters: 18,
    },
    {
        key: 'atlantic_white_cypress_chamaecyparis_thyoides',
        display_name: 'Atlantic white cypress (Chamaecyparis thyoides)',
        tupuake_id: 178,
        predominant_species_key: 'cypresses',
        mature_height_meters: undefined,
    },
    {
        key: 'atlas__atlantica_cedar_c_atlantica',
        display_name: 'Atlas/atlantica cedar (C. atlantica)',
        tupuake_id: 179,
        predominant_species_key: 'cedars__firs__larches__spruces__hemlocks',
        mature_height_meters: 20,
    },
    {
        key: 'australian_blackwood_acacia_melanoxylon',
        display_name: 'Australian blackwood (Acacia melanoxylon)',
        tupuake_id: 180,
        predominant_species_key: 'acacias',
        mature_height_meters: 20,
    },
    {
        key: 'beilschmiedia_tarairi',
        display_name: 'Beilschmiedia tarairi',
        tupuake_id: 14,
        predominant_species_key: 'broadleaved_species',
        mature_height_meters: 22,
    },
    {
        key: 'beilschmiedia_tawa',
        display_name: 'Beilschmiedia tawa',
        tupuake_id: 15,
        predominant_species_key: 'broadleaved_species',
        mature_height_meters: 35,
    },
    {
        key: 'big_cone_pine_p_coulteri',
        display_name: 'Big cone pine (P. coulteri)',
        tupuake_id: 181,
        predominant_species_key: 'pines',
        mature_height_meters: undefined,
    },
    {
        key: 'bishop_pine_p_muricata',
        display_name: 'Bishop pine (P. muricata)',
        tupuake_id: 182,
        predominant_species_key: 'pines',
        mature_height_meters: 25,
    },
    {
        key: 'black_alder_alnus_glutinosa',
        display_name: 'Black alder (Alnus glutinosa)',
        tupuake_id: 183,
        predominant_species_key: 'maples__birches__alders',
        mature_height_meters: 15,
    },
    {
        key: 'black_wattle_acacia_mearnsii',
        display_name: 'Black wattle (Acacia mearnsii)',
        tupuake_id: 184,
        predominant_species_key: 'acacias',
        mature_height_meters: 20,
    },
    {
        key: 'black__corsican_pine_p_nigra',
        display_name: 'Black/Corsican pine (P. nigra)',
        tupuake_id: 185,
        predominant_species_key: 'pines',
        mature_height_meters: 30,
    },
    {
        key: 'brachyglottis_repanda',
        display_name: 'Brachyglottis repanda',
        tupuake_id: 16,
        predominant_species_key: 'broadleaved_species',
        mature_height_meters: 6,
    },
    {
        key: 'caribbean_pine_p_caribaea',
        display_name: 'Caribbean pine (P. caribaea)',
        tupuake_id: 186,
        predominant_species_key: 'pines',
        mature_height_meters: undefined,
    },
    {
        key: 'carpodetus_serratus',
        display_name: 'Carpodetus serratus',
        tupuake_id: 17,
        predominant_species_key: 'broadleaved_species',
        mature_height_meters: 10,
    },
    {
        key: 'catalpa_speciosa',
        display_name: 'Catalpa speciosa',
        tupuake_id: 19,
        predominant_species_key: 'poplars__aspens__paulownia__catalpa',
        mature_height_meters: 15,
    },
    {
        key: 'cherry_laurel_prunus_laurocerasus',
        display_name: 'Cherry laurel (Prunus laurocerasus)',
        tupuake_id: 187,
        predominant_species_key: 'fruit_and_nut',
        mature_height_meters: undefined,
    },
    {
        key: 'chestnut_castanea_sativa',
        display_name: 'Chestnut (Castanea sativa)',
        tupuake_id: 188,
        predominant_species_key: 'fruit_and_nut',
        mature_height_meters: undefined,
    },
    {
        key: 'contorta_or_lodgepole_pine_p_contorta',
        display_name: 'Contorta or lodgepole pine (P. contorta)',
        tupuake_id: 189,
        predominant_species_key: 'pines',
        mature_height_meters: 40,
    },
    {
        key: 'coprosma_grandifolia',
        display_name: 'Coprosma grandifolia',
        tupuake_id: 22,
        predominant_species_key: 'coprosmas',
        mature_height_meters: 6,
    },
    {
        key: 'coprosma_propinqua',
        display_name: 'Coprosma propinqua',
        tupuake_id: 23,
        predominant_species_key: 'coprosmas',
        mature_height_meters: 6,
    },
    {
        key: 'coprosma_robusta',
        display_name: 'Coprosma robusta',
        tupuake_id: 24,
        predominant_species_key: 'coprosmas',
        mature_height_meters: 6,
    },
    {
        key: 'cordyline_australis',
        display_name: 'Cordyline australis',
        tupuake_id: 25,
        predominant_species_key: 'broadleaved_species',
        mature_height_meters: 20,
    },
    {
        key: 'corynocarpus_laevigatus',
        display_name: 'Corynocarpus laevigatus',
        tupuake_id: 26,
        predominant_species_key: 'broadleaved_species',
        mature_height_meters: 15,
    },
    {
        key: 'crack_willow_salix_fragilis',
        display_name: 'Crack willow (Salix fragilis)',
        tupuake_id: 190,
        predominant_species_key: 'willows',
        mature_height_meters: 9,
    },
    {
        key: 'cyathea_cunninghamii',
        display_name: 'Cyathea cunninghamii',
        tupuake_id: 32,
        predominant_species_key: 'tree_ferns',
        mature_height_meters: undefined,
    },
    {
        key: 'cyathea_dealbata',
        display_name: 'Cyathea dealbata',
        tupuake_id: 33,
        predominant_species_key: 'tree_ferns',
        mature_height_meters: undefined,
    },
    {
        key: 'cyathea_medullaris',
        display_name: 'Cyathea medullaris',
        tupuake_id: 34,
        predominant_species_key: 'tree_ferns',
        mature_height_meters: undefined,
    },
    {
        key: 'cyathea_smithii',
        display_name: 'Cyathea smithii',
        tupuake_id: 35,
        predominant_species_key: 'tree_ferns',
        mature_height_meters: undefined,
    },
    {
        key: 'dacrycarpus_dacrydioides',
        display_name: 'Dacrycarpus dacrydioides',
        tupuake_id: 36,
        predominant_species_key: 'podocarps',
        mature_height_meters: 60,
    },
    {
        key: 'dacrydium_cupressinum',
        display_name: 'Dacrydium cupressinum',
        tupuake_id: 37,
        predominant_species_key: 'podocarps',
        mature_height_meters: 60,
    },
    {
        key: 'dicksonia_fibrosa',
        display_name: 'Dicksonia fibrosa',
        tupuake_id: 38,
        predominant_species_key: 'tree_ferns',
        mature_height_meters: 10,
    },
    {
        key: 'dicksonia_squarrosa',
        display_name: 'Dicksonia squarrosa',
        tupuake_id: 39,
        predominant_species_key: 'tree_ferns',
        mature_height_meters: 8,
    },
    {
        key: 'dodonaea_viscosa',
        display_name: 'Dodonaea viscosa',
        tupuake_id: 40,
        predominant_species_key: 'tree_ferns',
        mature_height_meters: 12,
    },
    {
        key: 'douglas_fir_pseudotsuga_menziesii',
        display_name: 'Douglas fir (Pseudotsuga menziesii)',
        tupuake_id: 192,
        predominant_species_key: 'douglas_fir',
        mature_height_meters: 35,
    },
    {
        key: 'dwarf_mountain_pine_p_mugo',
        display_name: 'Dwarf mountain pine (P. mugo)',
        tupuake_id: 193,
        predominant_species_key: 'pines',
        mature_height_meters: undefined,
    },
    {
        key: 'dysoxylum_spectabile',
        display_name: 'Dysoxylum spectabile',
        tupuake_id: 41,
        predominant_species_key: 'broadleaved_species',
        mature_height_meters: undefined,
    },
    {
        key: 'eastern_white_weymouth_p_strobus',
        display_name: 'Eastern white (Weymouth) (P. strobus)',
        tupuake_id: 194,
        predominant_species_key: 'pines',
        mature_height_meters: 50,
    },
    {
        key: 'elaeocarpus_dentatus',
        display_name: 'Elaeocarpus dentatus',
        tupuake_id: 42,
        predominant_species_key: 'broadleaved_species',
        mature_height_meters: 20,
    },
    {
        key: 'elaeocarpus_hookerianus',
        display_name: 'Elaeocarpus hookerianus',
        tupuake_id: 43,
        predominant_species_key: 'broadleaved_species',
        mature_height_meters: undefined,
    },
    {
        key: 'eucalyptus_botryoides',
        display_name: 'Eucalyptus botryoides',
        tupuake_id: 44,
        predominant_species_key: 'eucalypts',
        mature_height_meters: 40,
    },
    {
        key: 'eucalyptus_camaldulensis',
        display_name: 'Eucalyptus camaldulensis',
        tupuake_id: 45,
        predominant_species_key: 'eucalypts',
        mature_height_meters: 40,
    },
    {
        key: 'eucalyptus_citriodora',
        display_name: 'Eucalyptus citriodora',
        tupuake_id: 46,
        predominant_species_key: 'eucalypts',
        mature_height_meters: 40,
    },
    {
        key: 'eucalyptus_cladocalyx',
        display_name: 'Eucalyptus cladocalyx',
        tupuake_id: 47,
        predominant_species_key: 'eucalypts',
        mature_height_meters: 40,
    },
    {
        key: 'eucalyptus_dalrympleana',
        display_name: 'Eucalyptus dalrympleana',
        tupuake_id: 48,
        predominant_species_key: 'eucalypts',
        mature_height_meters: 40,
    },
    {
        key: 'eucalyptus_deglupta',
        display_name: 'Eucalyptus deglupta',
        tupuake_id: 49,
        predominant_species_key: 'eucalypts',
        mature_height_meters: 40,
    },
    {
        key: 'eucalyptus_delegatensis',
        display_name: 'Eucalyptus delegatensis',
        tupuake_id: 50,
        predominant_species_key: 'eucalypts',
        mature_height_meters: 40,
    },
    {
        key: 'eucalyptus_dendromorpha',
        display_name: 'Eucalyptus dendromorpha',
        tupuake_id: 51,
        predominant_species_key: 'eucalypts',
        mature_height_meters: 40,
    },
    {
        key: 'eucalyptus_fastigata',
        display_name: 'Eucalyptus fastigata',
        tupuake_id: 52,
        predominant_species_key: 'eucalypts',
        mature_height_meters: 40,
    },
    {
        key: 'eucalyptus_fraxinoides',
        display_name: 'Eucalyptus fraxinoides',
        tupuake_id: 53,
        predominant_species_key: 'eucalypts',
        mature_height_meters: 40,
    },
    {
        key: 'eucalyptus_globoidea',
        display_name: 'Eucalyptus globoidea',
        tupuake_id: 54,
        predominant_species_key: 'eucalypts',
        mature_height_meters: 40,
    },
    {
        key: 'eucalyptus_globulus',
        display_name: 'Eucalyptus globulus',
        tupuake_id: 55,
        predominant_species_key: 'eucalypts',
        mature_height_meters: 40,
    },
    {
        key: 'eucalyptus_grandis',
        display_name: 'Eucalyptus grandis',
        tupuake_id: 56,
        predominant_species_key: 'eucalypts',
        mature_height_meters: 40,
    },
    {
        key: 'eucalyptus_microcorys',
        display_name: 'Eucalyptus microcorys',
        tupuake_id: 57,
        predominant_species_key: 'eucalypts',
        mature_height_meters: 40,
    },
    {
        key: 'eucalyptus_muellerana',
        display_name: 'Eucalyptus muellerana',
        tupuake_id: 58,
        predominant_species_key: 'eucalypts',
        mature_height_meters: 40,
    },
    {
        key: 'eucalyptus_nitens',
        display_name: 'Eucalyptus nitens',
        tupuake_id: 59,
        predominant_species_key: 'eucalypts',
        mature_height_meters: 40,
    },
    {
        key: 'eucalyptus_obliqua',
        display_name: 'Eucalyptus obliqua',
        tupuake_id: 60,
        predominant_species_key: 'eucalypts',
        mature_height_meters: 40,
    },
    {
        key: 'eucalyptus_ovata',
        display_name: 'Eucalyptus ovata',
        tupuake_id: 61,
        predominant_species_key: 'eucalypts',
        mature_height_meters: 40,
    },
    {
        key: 'eucalyptus_pilularis',
        display_name: 'Eucalyptus pilularis',
        tupuake_id: 62,
        predominant_species_key: 'eucalypts',
        mature_height_meters: 40,
    },
    {
        key: 'eucalyptus_regnans',
        display_name: 'Eucalyptus regnans',
        tupuake_id: 63,
        predominant_species_key: 'eucalypts',
        mature_height_meters: 40,
    },
    {
        key: 'eucalyptus_robusta',
        display_name: 'Eucalyptus robusta',
        tupuake_id: 64,
        predominant_species_key: 'eucalypts',
        mature_height_meters: 40,
    },
    {
        key: 'eucalyptus_saligna',
        display_name: 'Eucalyptus saligna',
        tupuake_id: 65,
        predominant_species_key: 'eucalypts',
        mature_height_meters: 40,
    },
    {
        key: 'eucalyptus_tereticornis',
        display_name: 'Eucalyptus tereticornis',
        tupuake_id: 66,
        predominant_species_key: 'eucalypts',
        mature_height_meters: 40,
    },
    {
        key: 'european_larch_l_decidua',
        display_name: 'European larch (L. decidua)',
        tupuake_id: 195,
        predominant_species_key: 'cedars__firs__larches__spruces__hemlocks',
        mature_height_meters: 22,
    },
    {
        key: 'fagus_sylvatica',
        display_name: 'Fagus sylvatica',
        tupuake_id: 67,
        predominant_species_key: 'beeches__oaks',
        mature_height_meters: 30,
    },
    {
        key: 'false_acacia_robinia_pseudoacacia',
        display_name: 'False acacia (Robinia pseudoacacia)',
        tupuake_id: 197,
        predominant_species_key: 'acacias',
        mature_height_meters: 25,
    },
    {
        key: 'fruit_and_nut_species',
        display_name: 'Fruit and Nut species',
        tupuake_id: 173,
        predominant_species_key: 'fruit_and_nut',
        mature_height_meters: undefined,
    },
    {
        key: 'fuschia_excorticata',
        display_name: 'Fuschia excorticata',
        tupuake_id: 68,
        predominant_species_key: 'broadleaved_species',
        mature_height_meters: undefined,
    },
    {
        key: 'grand_fir_abies_grandis',
        display_name: 'Grand fir (Abies grandis)',
        tupuake_id: 198,
        predominant_species_key: 'cedars__firs__larches__spruces__hemlocks',
        mature_height_meters: undefined,
    },
    {
        key: 'grey_willow_salix_cinerea',
        display_name: 'Grey willow (Salix cinerea)',
        tupuake_id: 199,
        predominant_species_key: 'willows',
        mature_height_meters: 9,
    },
    {
        key: 'griselinia_littoralis',
        display_name: 'Griselinia littoralis',
        tupuake_id: 69,
        predominant_species_key: 'broadleaved_species',
        mature_height_meters: undefined,
    },
    {
        key: 'hairy__white_birch_b_pubescens',
        display_name: 'Hairy/White birch (B. pubescens)',
        tupuake_id: 200,
        predominant_species_key: 'maples__birches__alders',
        mature_height_meters: 15,
    },
    {
        key: 'hawthorn_crataegus_monogyna',
        display_name: 'Hawthorn (Crataegus monogyna)',
        tupuake_id: 201,
        predominant_species_key: 'hawthorn',
        mature_height_meters: 10,
    },
    {
        key: 'hedycarya_arborea',
        display_name: 'Hedycarya arborea',
        tupuake_id: 70,
        predominant_species_key: 'broadleaved_species',
        mature_height_meters: 12,
    },
    {
        key: 'himalayan__deodar_cedar_c_deodara',
        display_name: 'Himalayan/deodar cedar (C. deodara)',
        tupuake_id: 202,
        predominant_species_key: 'cedars__firs__larches__spruces__hemlocks',
        mature_height_meters: 20,
    },
    {
        key: 'hoheria_angustifolia',
        display_name: 'Hoheria angustifolia',
        tupuake_id: 71,
        predominant_species_key: 'broadleaved_species',
        mature_height_meters: 18,
    },
    {
        key: 'hoheria_populnea',
        display_name: 'Hoheria populnea',
        tupuake_id: 72,
        predominant_species_key: 'broadleaved_species',
        mature_height_meters: 8,
    },
    {
        key: 'indigenous',
        display_name: 'Indigenous',
        tupuake_id: 174,
        predominant_species_key: 'indigenous',
        mature_height_meters: undefined,
    },
    {
        key: 'ixerba_brexioides',
        display_name: 'Ixerba brexioides',
        tupuake_id: 73,
        predominant_species_key: 'broadleaved_species',
        mature_height_meters: 10,
    },
    {
        key: 'jack_pine_p_banksiana',
        display_name: 'Jack pine (P. banksiana)',
        tupuake_id: 203,
        predominant_species_key: 'pines',
        mature_height_meters: 10,
    },
    {
        key: 'japanese_cedar_cryptomeria_japonica',
        display_name: 'Japanese cedar (Cryptomeria japonica)',
        tupuake_id: 204,
        predominant_species_key: 'cedars__firs__larches__spruces__hemlocks',
        mature_height_meters: 20,
    },
    {
        key: 'japanese_larch_larix_kaempferi',
        display_name: 'Japanese larch (Larix kaempferi)',
        tupuake_id: 205,
        predominant_species_key: 'cedars__firs__larches__spruces__hemlocks',
        mature_height_meters: 22,
    },
    {
        key: 'japanese_spindle_tree_euonymus_japonicus',
        display_name: 'Japanese spindle tree (Euonymus japonicus)',
        tupuake_id: 206,
        predominant_species_key: 'japanese_spindle_tree',
        mature_height_meters: 7,
    },
    {
        key: 'juglans_nigra',
        display_name: 'Juglans nigra',
        tupuake_id: 74,
        predominant_species_key: 'beeches__oaks',
        mature_height_meters: 15,
    },
    {
        key: 'kanuka_kunzea_ericoides',
        display_name: 'Kanuka (Kunzea ericoides)',
        tupuake_id: 207,
        predominant_species_key: 'manuka__kanuka',
        mature_height_meters: 30,
    },
    {
        key: 'knightia_excelsa',
        display_name: 'Knightia excelsa',
        tupuake_id: 75,
        predominant_species_key: 'broadleaved_species',
        mature_height_meters: 30,
    },
    {
        key: 'lagarostrobus_colensoi',
        display_name: 'Lagarostrobus colensoi',
        tupuake_id: 77,
        predominant_species_key: 'podocarps',
        mature_height_meters: undefined,
    },
    {
        key: 'laurelia_novae_zelandiae',
        display_name: 'Laurelia novae-zelandiae',
        tupuake_id: 80,
        predominant_species_key: 'broadleaved_species',
        mature_height_meters: 35,
    },
    {
        key: 'lawson_cypress_chamaecyparis_lawsoniana',
        display_name: 'Lawson cypress (Chamaecyparis lawsoniana)',
        tupuake_id: 208,
        predominant_species_key: 'cypresses',
        mature_height_meters: 50,
    },
    {
        key: 'leyland_cypress_cupressocyparis_leylandii',
        display_name: 'Leyland cypress (Cupressocyparis leylandii)',
        tupuake_id: 209,
        predominant_species_key: 'cypresses',
        mature_height_meters: undefined,
    },
    {
        key: 'libocedrus_bidwillii',
        display_name: 'Libocedrus bidwillii',
        tupuake_id: 82,
        predominant_species_key: 'podocarps',
        mature_height_meters: 30,
    },
    {
        key: 'libocedrus_plumosa',
        display_name: 'Libocedrus plumosa',
        tupuake_id: 83,
        predominant_species_key: 'podocarps',
        mature_height_meters: 35,
    },
    {
        key: 'litsea_calicaris',
        display_name: 'Litsea calicaris',
        tupuake_id: 84,
        predominant_species_key: 'broadleaved_species',
        mature_height_meters: 18,
    },
    {
        key: 'loblolly_pine_p_taeda',
        display_name: 'Loblolly pine (P. taeda)',
        tupuake_id: 210,
        predominant_species_key: 'pines',
        mature_height_meters: 30,
    },
    {
        key: 'longleaf_pine_p_palustris',
        display_name: 'Longleaf pine (P. palustris)',
        tupuake_id: 211,
        predominant_species_key: 'pines',
        mature_height_meters: undefined,
    },
    {
        key: 'manuka_leptospermum_scoparium',
        display_name: 'Manuka (Leptospermum scoparium)',
        tupuake_id: 212,
        predominant_species_key: 'manuka__kanuka',
        mature_height_meters: 10,
    },
    {
        key: 'maritime_pine_p_pinaster',
        display_name: 'Maritime pine (P. pinaster)',
        tupuake_id: 213,
        predominant_species_key: 'pines',
        mature_height_meters: undefined,
    },
    {
        key: 'melicytus_lancelolatus',
        display_name: 'Melicytus lancelolatus',
        tupuake_id: 85,
        predominant_species_key: 'broadleaved_species',
        mature_height_meters: undefined,
    },
    {
        key: 'melicytus_ramiflorus',
        display_name: 'Melicytus ramiflorus',
        tupuake_id: 86,
        predominant_species_key: 'broadleaved_species',
        mature_height_meters: 15,
    },
    {
        key: 'metrosideros_excelsa',
        display_name: 'Metrosideros excelsa',
        tupuake_id: 87,
        predominant_species_key: 'broadleaved_species',
        mature_height_meters: 20,
    },
    {
        key: 'metrosideros_robusta',
        display_name: 'Metrosideros robusta',
        tupuake_id: 88,
        predominant_species_key: 'broadleaved_species',
        mature_height_meters: 40,
    },
    {
        key: 'metrosideros_umbellata',
        display_name: 'Metrosideros umbellata',
        tupuake_id: 89,
        predominant_species_key: 'broadleaved_species',
        mature_height_meters: undefined,
    },
    {
        key: 'mexican_cyress_cupressus_lusitanica',
        display_name: 'Mexican cyress (Cupressus lusitanica)',
        tupuake_id: 214,
        predominant_species_key: 'cypresses',
        mature_height_meters: 35,
    },
    {
        key: 'mexican_weeping_pine_p_patula',
        display_name: 'Mexican weeping pine (P. patula)',
        tupuake_id: 215,
        predominant_species_key: 'pines',
        mature_height_meters: 30,
    },
    {
        key: 'mexican_white_pine_p_ayacahuite',
        display_name: 'Mexican white pine (P. ayacahuite)',
        tupuake_id: 216,
        predominant_species_key: 'pines',
        mature_height_meters: undefined,
    },
    {
        key: 'monoao_colensoi',
        display_name: 'Monoao colensoi',
        tupuake_id: 90,
        predominant_species_key: 'podocarps',
        mature_height_meters: undefined,
    },
    {
        key: 'monterey_cypress_cupressus_macrocarpa',
        display_name: 'Monterey cypress (Cupressus macrocarpa)',
        tupuake_id: 217,
        predominant_species_key: 'cypresses',
        mature_height_meters: 36,
    },
    {
        key: 'mountain_pine_p_uncinata',
        display_name: 'Mountain pine (P. uncinata)',
        tupuake_id: 218,
        predominant_species_key: 'pines',
        mature_height_meters: undefined,
    },
    {
        key: 'myoporum_laetum',
        display_name: 'Myoporum laetum',
        tupuake_id: 91,
        predominant_species_key: 'broadleaved_species',
        mature_height_meters: 10,
    },
    {
        key: 'myrsine_australis',
        display_name: 'Myrsine australis',
        tupuake_id: 92,
        predominant_species_key: 'broadleaved_species',
        mature_height_meters: 6,
    },
    {
        key: 'myrsine_salicina',
        display_name: 'Myrsine salicina',
        tupuake_id: 93,
        predominant_species_key: 'broadleaved_species',
        mature_height_meters: 10,
    },
    {
        key: 'nestigis_cunninghamii',
        display_name: 'Nestigis cunninghamii',
        tupuake_id: 94,
        predominant_species_key: 'broadleaved_species',
        mature_height_meters: 25,
    },
    {
        key: 'nestigis_lanceolata',
        display_name: 'Nestigis lanceolata',
        tupuake_id: 95,
        predominant_species_key: 'broadleaved_species',
        mature_height_meters: 20,
    },
    {
        key: 'nestigis_montana',
        display_name: 'Nestigis montana',
        tupuake_id: 96,
        predominant_species_key: 'broadleaved_species',
        mature_height_meters: 15,
    },
    {
        key: 'nootka_cypress_callitropsis_nootkatensis',
        display_name: 'Nootka cypress (Callitropsis nootkatensis)',
        tupuake_id: 219,
        predominant_species_key: 'cypresses',
        mature_height_meters: undefined,
    },
    {
        key: 'norway_spruce_picea_abies',
        display_name: 'Norway spruce (Picea abies)',
        tupuake_id: 220,
        predominant_species_key: 'cedars__firs__larches__spruces__hemlocks',
        mature_height_meters: undefined,
    },
    {
        key: 'nothofagus_fusca',
        display_name: 'Nothofagus fusca',
        tupuake_id: 97,
        predominant_species_key: 'beeches',
        mature_height_meters: 20,
    },
    {
        key: 'nothofagus_menziesii',
        display_name: 'Nothofagus menziesii',
        tupuake_id: 98,
        predominant_species_key: 'beeches',
        mature_height_meters: 20,
    },
    {
        key: 'nothofagus_solandri_var_cliffortioides',
        display_name: 'Nothofagus solandri var. cliffortioides',
        tupuake_id: 99,
        predominant_species_key: 'beeches',
        mature_height_meters: 20,
    },
    {
        key: 'nothofagus_solandri_var_solandri',
        display_name: 'Nothofagus solandri var. solandri',
        tupuake_id: 100,
        predominant_species_key: 'beeches',
        mature_height_meters: 20,
    },
    {
        key: 'nothofagus_truncata',
        display_name: 'Nothofagus truncata',
        tupuake_id: 101,
        predominant_species_key: 'beeches',
        mature_height_meters: 20,
    },
    {
        key: 'olearia_paniculata',
        display_name: 'Olearia paniculata',
        tupuake_id: 102,
        predominant_species_key: 'broadleaved_species',
        mature_height_meters: undefined,
    },
    {
        key: 'olearia_rani',
        display_name: 'Olearia rani',
        tupuake_id: 103,
        predominant_species_key: 'broadleaved_species',
        mature_height_meters: undefined,
    },
    {
        key: 'olearia_traversii',
        display_name: 'Olearia traversii',
        tupuake_id: 104,
        predominant_species_key: 'broadleaved_species',
        mature_height_meters: undefined,
    },
    {
        key: 'other_poplar_species_and_hybrids',
        display_name: 'Other poplar species and hybrids',
        tupuake_id: 221,
        predominant_species_key: 'poplars__aspens__paulownia__catalpa',
        mature_height_meters: 15,
    },
    {
        key: 'other_willow_species_and_hybrids',
        display_name: 'Other willow species and hybrids',
        tupuake_id: 222,
        predominant_species_key: 'willows',
        mature_height_meters: 9,
    },
    {
        key: 'pacific_silver_fir_abies_amabilis',
        display_name: 'Pacific silver fir (Abies amabilis)',
        tupuake_id: 223,
        predominant_species_key: 'cedars__firs__larches__spruces__hemlocks',
        mature_height_meters: undefined,
    },
    {
        key: 'paratrophis_banksii',
        display_name: 'Paratrophis banksii',
        tupuake_id: 106,
        predominant_species_key: 'broadleaved_species',
        mature_height_meters: undefined,
    },
    {
        key: 'paratrophis_microphylla',
        display_name: 'Paratrophis microphylla',
        tupuake_id: 107,
        predominant_species_key: 'broadleaved_species',
        mature_height_meters: undefined,
    },
    {
        key: 'paulownia_tomentosa',
        display_name: 'Paulownia tomentosa',
        tupuake_id: 108,
        predominant_species_key: 'poplars__aspens__paulownia__catalpa',
        mature_height_meters: 15,
    },
    {
        key: 'pennantia_corymbosa',
        display_name: 'Pennantia corymbosa',
        tupuake_id: 109,
        predominant_species_key: 'broadleaved_species',
        mature_height_meters: undefined,
    },
    {
        key: 'phyllocladus_alpinus',
        display_name: 'Phyllocladus alpinus',
        tupuake_id: 110,
        predominant_species_key: 'podocarps',
        mature_height_meters: 6,
    },
    {
        key: 'phyllocladus_glaucus',
        display_name: 'Phyllocladus glaucus',
        tupuake_id: 111,
        predominant_species_key: 'podocarps',
        mature_height_meters: undefined,
    },
    {
        key: 'phyllocladus_trichomanoides',
        display_name: 'Phyllocladus trichomanoides',
        tupuake_id: 112,
        predominant_species_key: 'podocarps',
        mature_height_meters: 25,
    },
    {
        key: 'pinus_radiata',
        display_name: 'Pinus radiata',
        tupuake_id: 131,
        predominant_species_key: 'pinus_radiata',
        mature_height_meters: 30,
    },
    {
        key: 'pinus_strobus',
        display_name: 'Pinus strobus',
        tupuake_id: 132,
        predominant_species_key: 'pinus_radiata',
        mature_height_meters: 30,
    },
    {
        key: 'pittosporum_crassifolium',
        display_name: 'Pittosporum crassifolium',
        tupuake_id: 135,
        predominant_species_key: 'pittosporums',
        mature_height_meters: 10,
    },
    {
        key: 'pittosporum_eugenioides',
        display_name: 'Pittosporum eugenioides',
        tupuake_id: 136,
        predominant_species_key: 'pittosporums',
        mature_height_meters: 12,
    },
    {
        key: 'pittosporum_tenuifolium',
        display_name: 'Pittosporum tenuifolium',
        tupuake_id: 137,
        predominant_species_key: 'pittosporums',
        mature_height_meters: 10,
    },
    {
        key: 'plagianthus_regius',
        display_name: 'Plagianthus regius',
        tupuake_id: 138,
        predominant_species_key: 'broadleaved_species',
        mature_height_meters: undefined,
    },
    {
        key: 'podocarpus_hallii',
        display_name: 'Podocarpus hallii',
        tupuake_id: 139,
        predominant_species_key: 'podocarps',
        mature_height_meters: undefined,
    },
    {
        key: 'podocarpus_totara',
        display_name: 'Podocarpus totara',
        tupuake_id: 140,
        predominant_species_key: 'podocarps',
        mature_height_meters: 30,
    },
    {
        key: 'ponderosa_pine_p_ponderosa',
        display_name: 'Ponderosa pine (P. ponderosa)',
        tupuake_id: 224,
        predominant_species_key: 'pines',
        mature_height_meters: 30,
    },
    {
        key: 'populus_deltoides',
        display_name: 'Populus deltoides',
        tupuake_id: 142,
        predominant_species_key: 'poplars__aspens__paulownia__catalpa',
        mature_height_meters: 15,
    },
    {
        key: 'populus_nigra_italica',
        display_name: 'Populus nigra Italica',
        tupuake_id: 143,
        predominant_species_key: 'poplars__aspens__paulownia__catalpa',
        mature_height_meters: 15,
    },
    {
        key: 'populus_yunnanensis',
        display_name: 'Populus yunnanensis',
        tupuake_id: 144,
        predominant_species_key: 'poplars__aspens__paulownia__catalpa',
        mature_height_meters: 15,
    },
    {
        key: 'prumnopitys_ferruginea',
        display_name: 'Prumnopitys ferruginea',
        tupuake_id: 145,
        predominant_species_key: 'podocarps',
        mature_height_meters: undefined,
    },
    {
        key: 'prumnopitys_taxifolia',
        display_name: 'Prumnopitys taxifolia',
        tupuake_id: 146,
        predominant_species_key: 'podocarps',
        mature_height_meters: 30,
    },
    {
        key: 'pseudopanax_arboreus',
        display_name: 'Pseudopanax arboreus',
        tupuake_id: 147,
        predominant_species_key: 'broadleaved_species',
        mature_height_meters: 8,
    },
    {
        key: 'pseudopanax_colensoi',
        display_name: 'Pseudopanax colensoi',
        tupuake_id: 148,
        predominant_species_key: 'broadleaved_species',
        mature_height_meters: undefined,
    },
    {
        key: 'pseudopanax_crassifolius',
        display_name: 'Pseudopanax crassifolius',
        tupuake_id: 149,
        predominant_species_key: 'broadleaved_species',
        mature_height_meters: 15,
    },
    {
        key: 'pseudowintera_colorata',
        display_name: 'Pseudowintera colorata',
        tupuake_id: 151,
        predominant_species_key: 'broadleaved_species',
        mature_height_meters: 3.5,
    },
    {
        key: 'pussy_willow_salix_reichardtii',
        display_name: 'Pussy willow (Salix reichardtii)',
        tupuake_id: 225,
        predominant_species_key: 'willows',
        mature_height_meters: 9,
    },
    {
        key: 'quercus_robur',
        display_name: 'Quercus robur',
        tupuake_id: 152,
        predominant_species_key: 'beeches__oaks',
        mature_height_meters: 15,
    },
    {
        key: 'quintinia_acutifolia',
        display_name: 'Quintinia acutifolia',
        tupuake_id: 153,
        predominant_species_key: 'broadleaved_species',
        mature_height_meters: undefined,
    },
    {
        key: 'quintinia_serrata',
        display_name: 'Quintinia serrata',
        tupuake_id: 154,
        predominant_species_key: 'broadleaved_species',
        mature_height_meters: 12,
    },
    {
        key: 'raukawa_edgerleyi',
        display_name: 'Raukawa edgerleyi',
        tupuake_id: 155,
        predominant_species_key: 'broadleaved_species',
        mature_height_meters: 12,
    },
    {
        key: 'raukawa_simplex',
        display_name: 'Raukawa simplex',
        tupuake_id: 156,
        predominant_species_key: 'broadleaved_species',
        mature_height_meters: 8,
    },
    {
        key: 'redwood_sequoia_sempervirens',
        display_name: 'Redwood (Sequoia sempervirens)',
        tupuake_id: 226,
        predominant_species_key: 'redwood',
        mature_height_meters: 35,
    },
    {
        key: 'rhopalostylis_sapida',
        display_name: 'Rhopalostylis sapida',
        tupuake_id: 157,
        predominant_species_key: 'broadleaved_species',
        mature_height_meters: 15,
    },
    {
        key: 'rowan__mountain_ash_sorbus_aucuparia',
        display_name: 'Rowan/Mountain Ash (Sorbus aucuparia)',
        tupuake_id: 227,
        predominant_species_key: 'rowan__mountain_ash__ash',
        mature_height_meters: 18,
    },
    {
        key: 'schefflera_digitata',
        display_name: 'Schefflera digitata',
        tupuake_id: 161,
        predominant_species_key: 'broadleaved_species',
        mature_height_meters: 8,
    },
    {
        key: 'scots_pine_p_sylvestris',
        display_name: 'Scots pine (P. sylvestris)',
        tupuake_id: 228,
        predominant_species_key: 'pines',
        mature_height_meters: 35,
    },
    {
        key: 'shortleaf_pine_p_echinata',
        display_name: 'Shortleaf pine (P. echinata)',
        tupuake_id: 229,
        predominant_species_key: 'pines',
        mature_height_meters: undefined,
    },
    {
        key: 'sierra_redwood_sequoiadendron_giganteum',
        display_name: 'Sierra redwood (Sequoiadendron giganteum)',
        tupuake_id: 230,
        predominant_species_key: 'redwood',
        mature_height_meters: 35,
    },
    {
        key: 'silver_birch_b_pendula',
        display_name: 'Silver birch (B. pendula)',
        tupuake_id: 231,
        predominant_species_key: 'maples__birches__alders',
        mature_height_meters: 15,
    },
    {
        key: 'silver_wattle_acacia_dealbata',
        display_name: 'Silver wattle (Acacia dealbata)',
        tupuake_id: 232,
        predominant_species_key: 'acacias',
        mature_height_meters: undefined,
    },
    {
        key: 'sitka_spruce_picea_sitchensis',
        display_name: 'Sitka spruce (Picea sitchensis)',
        tupuake_id: 233,
        predominant_species_key: 'cedars__firs__larches__spruces__hemlocks',
        mature_height_meters: undefined,
    },
    {
        key: 'slash_pine_p_elliottii',
        display_name: 'Slash pine (P. elliottii)',
        tupuake_id: 234,
        predominant_species_key: 'pines',
        mature_height_meters: undefined,
    },
    {
        key: 'sophora_microphylla',
        display_name: 'Sophora microphylla',
        tupuake_id: 163,
        predominant_species_key: 'broadleaved_species',
        mature_height_meters: undefined,
    },
    {
        key: 'sophora_tetraptera',
        display_name: 'Sophora tetraptera',
        tupuake_id: 164,
        predominant_species_key: 'broadleaved_species',
        mature_height_meters: 15,
    },
    {
        key: 'sugar_pine_p_lambertiana',
        display_name: 'Sugar pine (P. lambertiana)',
        tupuake_id: 235,
        predominant_species_key: 'pines',
        mature_height_meters: undefined,
    },
    {
        key: 'sycamore_acer_pseudoplatanus',
        display_name: 'Sycamore (Acer pseudoplatanus)',
        tupuake_id: 236,
        predominant_species_key: 'maples__birches__alders',
        mature_height_meters: 22,
    },
    {
        key: 'syncarpia_glomulifera',
        display_name: 'Syncarpia glomulifera',
        tupuake_id: 165,
        predominant_species_key: 'eucalypts',
        mature_height_meters: 40,
    },
    {
        key: 'syzygium_maire',
        display_name: 'Syzygium maire',
        tupuake_id: 166,
        predominant_species_key: 'broadleaved_species',
        mature_height_meters: 16,
    },
    {
        key: 'taiwan_cherry_prunus_campanulata',
        display_name: 'Taiwan cherry (Prunus campanulata)',
        tupuake_id: 237,
        predominant_species_key: 'fruit_and_nut',
        mature_height_meters: undefined,
    },
    {
        key: 'toronia_toru',
        display_name: 'Toronia toru',
        tupuake_id: 168,
        predominant_species_key: 'broadleaved_species',
        mature_height_meters: 12,
    },
    {
        key: 'tortured_willow_salix_matsudana',
        display_name: 'Tortured willow (Salix matsudana)',
        tupuake_id: 238,
        predominant_species_key: 'willows',
        mature_height_meters: 9,
    },
    {
        key: 'vitex_lucens',
        display_name: 'Vitex lucens',
        tupuake_id: 169,
        predominant_species_key: 'broadleaved_species',
        mature_height_meters: 20,
    },
    {
        key: 'weinmannia_racemosa',
        display_name: 'Weinmannia racemosa',
        tupuake_id: 170,
        predominant_species_key: 'broadleaved_species',
        mature_height_meters: 25,
    },
    {
        key: 'weinmannia_silvicola',
        display_name: 'Weinmannia silvicola',
        tupuake_id: 171,
        predominant_species_key: 'broadleaved_species',
        mature_height_meters: 15,
    },
    {
        key: 'western_hemlock_tsuga_heterophylla',
        display_name: 'Western hemlock (Tsuga heterophylla)',
        tupuake_id: 239,
        predominant_species_key: 'cedars__firs__larches__spruces__hemlocks',
        mature_height_meters: undefined,
    },
    {
        key: 'western_red_cedar_thuja_plicata',
        display_name: 'Western red cedar (Thuja plicata)',
        tupuake_id: 240,
        predominant_species_key: 'cedars__firs__larches__spruces__hemlocks',
        mature_height_meters: 20,
    },
    {
        key: 'western_white_pine_p_monticola',
        display_name: 'Western white pine (P. monticola)',
        tupuake_id: 241,
        predominant_species_key: 'pines',
        mature_height_meters: undefined,
    },
    {
        key: 'white_fir_abies_concolor',
        display_name: 'White fir (Abies concolor)',
        tupuake_id: 242,
        predominant_species_key: 'cedars__firs__larches__spruces__hemlocks',
        mature_height_meters: undefined,
    },
    {
        key: 'white_willow_salix_alba',
        display_name: 'White willow (Salix alba)',
        tupuake_id: 243,
        predominant_species_key: 'willows',
        mature_height_meters: 9,
    },
    {
        key: 'white__silver_poplar_populus_alba',
        display_name: 'White/Silver poplar (Populus alba)',
        tupuake_id: 244,
        predominant_species_key: 'poplars__aspens__paulownia__catalpa',
        mature_height_meters: 15,
    },
    {
        key: 'wild_cherry__gean_prunus_avium',
        display_name: 'Wild cherry/gean (Prunus avium)',
        tupuake_id: 245,
        predominant_species_key: 'fruit_and_nut',
        mature_height_meters: undefined,
    },
];
exports.tree_species_list = exports.tree_species.map((ts) => ts.key);
exports.tree_species_map = (0, util_1.toMap)(exports.tree_species);
const getTreeSpeciesByKey = (species) => exports.tree_species_map[species];
exports.getTreeSpeciesByKey = getTreeSpeciesByKey;
